// @utilities
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;

// @constants
const {
    ACCOUNT_DEFER_PAYMENT_NAVIGATION,
    ACCOUNT_DETAILS_NAVIGATION,
    ACCOUNT_MOVEMENT_NAVIGATION,
    ACCOUNT_MOVEMENTS_NAVIGATION,
    ACCOUNTS_LANDING_NAVIGATION,
    APPLE_PAY_NAVIGATION,
    ATM_FINDER_NAVIGATION,
    BIZUM_PAY_NAVIGATION,
    CARD_CONTROL_NAVIGATION,
    CARD_DEPOSIT_MONEY_NAVIGATION,
    CARD_DETAILS_NAVIGATION,
    CARD_LIMIT_CHANGE,
    CARD_MOVEMENT_NAVIGATION,
    CARD_MOVEMENTS_NAVIGATION,
    CARDS_LANDING_NAVIGATION,
    CTA_LINKS,
    EMITED_TRANSFER_MOVEMENT_NAVIGATION,
    EXPENSES_NAVIGATION,
    FUNDS_LANDING_NAVIGATION,
    GOOGLE_PAY_NAVIGATION,
    HIRE_AHAC_CARD_NAVIGATION,
    HIRE_OC_CARD_NAVIGATION,
    HIRE_SAVING_ACCOUNT_NAVIGATION,
    LOANS_LANDING_NAVIGATION,
    OPENBANK_PAY_NAVIGATION,
    PASS_NAVIGATION,
    PROD_URL,
    ROBO_LANDING_NAVIGATION,
    TRANSFER_NAVIGATION,
    USER_PROFILE_NAVIGATION,
} = require('constants/personeticsLinks');

const handleRedirect = (path, isOpenInNewTab, history) => {
    if (path.includes("https")) {
        isOpenInNewTab ? window.open(path, '_blank') : window.open(path, '_self');
    } else {
        history.push(path);
    }
}

const getLanguageBasedSubUrl = (navTarget) => {
    const language = getLanguage();
    let subUrl = '';

    switch (navTarget) {
        case GOOGLE_PAY_NAVIGATION:
            subUrl = language === 'es' ? CTA_LINKS.GOOGLE_PAY_ES : CTA_LINKS.GOOGLE_PAY_EN;
            break;
        case APPLE_PAY_NAVIGATION:
            subUrl = language === 'es' ? CTA_LINKS.APPLE_PAY_ES : CTA_LINKS.APPLE_PAY_EN;
            break;
        case BIZUM_PAY_NAVIGATION:
            subUrl = language === 'es' ? CTA_LINKS.BIZUM_PAY_ES : CTA_LINKS.BIZUM_PAY_EN;
            break;
        case OPENBANK_PAY_NAVIGATION:
            subUrl = language === 'es' ? CTA_LINKS.OPENBANK_PAY_ES : CTA_LINKS.OPENBANK_PAY_EN;
            break;
        default:
            break;
    }
    return subUrl;
}

const PersoneticsNavigation = {

    getNavigation(NavigateTarget, accountId, cardId, movementId, history, isOpenInNewTab = false) {
        const defaultpath = '/myprofile';
        const publicSiteUrl = getPublicSiteUrl();
        const prodUrl = PROD_URL;
        const languageBasedSubUrl = getLanguageBasedSubUrl(NavigateTarget);

        const navigationMapping = {
            [ACCOUNT_DEFER_PAYMENT_NAVIGATION]: `${defaultpath}/accounts/${accountId}/defer-payment/${movementId}`,
            [ACCOUNT_DETAILS_NAVIGATION]: `${defaultpath}/accounts/${accountId}/details`,
            [ACCOUNT_MOVEMENT_NAVIGATION]: `${defaultpath}/accounts/${accountId}/movements`,
            [ACCOUNT_MOVEMENTS_NAVIGATION]: `${defaultpath}/accounts/${accountId}/movements`,
            [ACCOUNTS_LANDING_NAVIGATION]: `${defaultpath}/accounts`,
            [APPLE_PAY_NAVIGATION]: `${prodUrl}/${languageBasedSubUrl}`,
            [ATM_FINDER_NAVIGATION]: `${publicSiteUrl}/cajeros-oficinas`,
            [BIZUM_PAY_NAVIGATION]: `${prodUrl}/${languageBasedSubUrl}`,
            [CARD_CONTROL_NAVIGATION]: `${defaultpath}/cards/config/${cardId}`,
            [CARD_DEPOSIT_MONEY_NAVIGATION]: `${defaultpath}/cards/${cardId}/deposit-money`,
            [CARD_DETAILS_NAVIGATION]: `${defaultpath}/cards/${cardId}/details`,
            [CARD_LIMIT_CHANGE]: `${defaultpath}/cards/${cardId}/modify-limit`,
            [CARD_MOVEMENT_NAVIGATION]: `${defaultpath}/cards/${cardId}/movements`,
            [CARD_MOVEMENTS_NAVIGATION]: `${defaultpath}/cards/${cardId}/movements`,
            [CARDS_LANDING_NAVIGATION]: `${defaultpath}/cards`,
            [EMITED_TRANSFER_MOVEMENT_NAVIGATION]: `${defaultpath}/transfers/emited/${accountId}`,
            [EXPENSES_NAVIGATION]: `${defaultpath}/global/expenses-by-category/all-categories/Debit and credit/All accounts`,
            [FUNDS_LANDING_NAVIGATION]: `${defaultpath}/broker/funds`,
            [GOOGLE_PAY_NAVIGATION]: `${prodUrl}/${languageBasedSubUrl}`,
            [HIRE_AHAC_CARD_NAVIGATION]: `${defaultpath}/hire/card/at-home-abroad`,
            [HIRE_OC_CARD_NAVIGATION]: `${defaultpath}/hire/card/open-credit`,
            [HIRE_SAVING_ACCOUNT_NAVIGATION]: `${defaultpath}/purchase/e-account-loan`,
            [LOANS_LANDING_NAVIGATION]: `${defaultpath}/loans-mortgages`,
            [OPENBANK_PAY_NAVIGATION]: `${prodUrl}/${languageBasedSubUrl}`,
            [PASS_NAVIGATION]: `${defaultpath}/transfers/pass/${accountId}`,
            [ROBO_LANDING_NAVIGATION]: `${defaultpath}/broker/general/robo`,
            [TRANSFER_NAVIGATION]: `${defaultpath}/transfers/transfer/${accountId}`,
            [USER_PROFILE_NAVIGATION]: `${defaultpath}/edit`,
        }
        if (navigationMapping.hasOwnProperty(NavigateTarget)) {
            handleRedirect(navigationMapping[NavigateTarget], isOpenInNewTab, history);
        }
    }
}

module.exports = PersoneticsNavigation;
